"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.prepareVisibleDate = exports.shitVisibleDateByOne = exports.calculateNextVisibleWeekDates = exports.getCurrentWeekDateRange = exports.dateToString = void 0;
const dateToString = (d, isCompact, weekView, visibleDates) => {
    var _a, _b;
    const dateFormat = isCompact ? `ddd D MMM` : `ddd[\r\n]D MMM`;
    if (isCompact && weekView) {
        return [
            (_a = visibleDates[0]) === null || _a === void 0 ? void 0 : _a.format("D"),
            "t/m",
            (_b = visibleDates[visibleDates.length - 1]) === null || _b === void 0 ? void 0 : _b.format("D MMM")
        ].join(" ");
    }
    return d.format(dateFormat);
};
exports.dateToString = dateToString;
const getCurrentWeekDateRange = (visibleDates) => {
    if (!visibleDates || !visibleDates.length)
        return null;
    return {
        from: visibleDates[0].format("YYYY-MM-DD"),
        to: visibleDates[visibleDates.length - 1].format("YYYY-MM-DD")
    };
};
exports.getCurrentWeekDateRange = getCurrentWeekDateRange;
const calculateNextVisibleWeekDates = (visibleDates, isPast = true) => {
    const value = isPast ? -7 : 7;
    return visibleDates.map((date) => date.add(value, "d"));
};
exports.calculateNextVisibleWeekDates = calculateNextVisibleWeekDates;
const shitVisibleDateByOne = (visibleDates, isPast = true) => {
    const value = isPast ? -1 : 1;
    return visibleDates.map((date) => date.add(value, "d"));
};
exports.shitVisibleDateByOne = shitVisibleDateByOne;
const prepareVisibleDate = (initialDate) => {
    return [...Array(7).keys()]
        .map((i) => {
        return initialDate.clone().add(-i, "d");
    })
        .reverse();
};
exports.prepareVisibleDate = prepareVisibleDate;
//# sourceMappingURL=utils.js.map